export default new class {
  constructor() {
    this.footprints = {}
    this.alphabet = "XEROPHYTICS"; //https://www.morewords.com/unique-letters/10x/
  }

  next() {
    let id = (new Date).valueOf() + ""

    if (id in this.footprints) {
      this.footprints[id] += 1
    } else {
      this.footprints = {
        [id]: 0
      }
    }
    return this.alphabet.charAt(+((this.footprints[id] + "").substr(-1))) + (id + this.footprints[id]) + (Math.random() + "").substr(2)
  }

  join(...ids) {
    // https://www.w3.org/TR/html4/types.html#type-id
    return ids.join(":")
  }

  split(id) {
    return (id || "").split(":")
  }
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/IdManager/index.js